import {API} from "@/Composables/api";

const getTags = async (params = {}) => {
    return API.get(route("tags.index"), params);
};

const storeTag = async (tag) => {
    return API.post(route("tags.store"), tag);
};

export {getTags, storeTag};
